import { SELECT_LIGHTBOX_IMAGE } from '../actions/actions'

const initialState = {
  lightBoxImage: null
}
const index = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_LIGHTBOX_IMAGE:
      return {
        ...state,
        lightBoxImage: action.img
      }
    default:
      return state
  }
}

export default index
